<template>
    
    <router-link :to="to" 
                 aria-current="page"
                 class="group border-l-4 px-3 py-2 flex items-center text-sm font-medium"
                 :class="[isActive ? 'bg-blue-50 border-blue-500 text-blue-700 hover:bg-blue-50 hover:text-blue-700' : 'border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900']"
                 >
   
        <heroicon v-if="icon" :icon="icon" class="flex-shrink-0 -ml-1 mr-3 h-6 w-6"
            :class="[isActive ? 'text-blue-700 group-hover:text-blue-700' : 'text-gray-400 group-hover:text-gray-500']">
        </heroicon>
        <component v-else
            :is="heroicon"
            class="flex-shrink-0 -ml-1 mr-3 h-6 w-6"
            :class="[isActive ? 'text-blue-700 group-hover:text-blue-700' : 'text-gray-400 group-hover:text-gray-500']"
        />
        
        <span class="truncate flex-grow">
            <slot></slot>
        </span>

        <span v-if="!!notification" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-600 text-white">
            {{ notification }}
        </span>

    </router-link>

</template>
<script>
export default {
    components: {
        'heroicon': () => import('./Heroicon')
    },
    props: ['to', 'icon', 'notification', 'heroicon'],
    computed: {
        isActive() {
            return this.to === this.$route.path
        }
    }
}
</script>